"use client";

import { useEffect, useRef } from "react";

interface WheelLockProps {
  children: React.ReactNode;
  className?: string;
}

export function WheelLock({ children, className }: WheelLockProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const stop = (e: WheelEvent) => e.preventDefault();
    el.addEventListener("wheel", stop, { passive: false });
    return () => el.removeEventListener("wheel", stop);
  }, []);

  return (
    <div ref={ref} className={className} data-lenis-prevent>
      {children}
    </div>
  );
}
